<div *ngIf="itentFromEshare && !filterCtaApplied">
  <div style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(0,0,0,.72); backdrop-filter: saturate(180%) blur(10px); z-index: 9999; display: block;"></div>
  <div class="reveal-modal rs-reveal-modal-loading open" role="alert" style="visibility: visible;">
    <div class="rs-spinner-neg" aria-live="polite" aria-label="{{'products.overview.loadingCta.label' | translate }}" title="Loading" aria-busy="true"></div>
    <div class="rs-modal-content">
      {{ 'products.overview.loadingCta.label' | translate }}
    </div>
  </div>
</div>

<section
  class="rs-content-wrapper rs-header-has-level2"
  *ngIf="overviewDataLoaded || showProducts || isPending"
>
  <main id="maincontent" role="main">
    <div class="rs-bg-grey3 rs-pos-rel">
      <mprd-skeleton-overview *ngIf="!showProducts || isPending"></mprd-skeleton-overview>
      <section class="rs-es-first-section" *ngIf="showProducts && !isPending">
        <mprd-back-link></mprd-back-link>
        <div class="row">
          <div class="columns small-12">
            <div class="rs-pos-rel">
              <h1 class="rs-tit1-sp rs-txt-c2 rs-padding-bottom4">
                {{ 'products.overview.title' | translate }}
              </h1>
              <mprd-address-selector
                [addresses]="installationAddresses"
                [showNoAddress]="hasProductWithoutAddress"
                [hidden]="shouldHideSelector()"
              ></mprd-address-selector>
              <px-alert
                [alerts]="[
                  {
                    type: 'info',
                    description: 'overview.error.emptyInstallBase' | translate,
                    isClosable: false,
                    useNegativeColors: true
                  }
                ]"
                *ngIf="emptyInstallBase"
              ></px-alert>
              <px-alert
                [alerts]="[
                  {
                    type: 'info',
                    description: 'overview.error.emptyInstallBaseCeaseCust' | translate,
                    isClosable: false,
                    useNegativeColors: true
                  }
                ]"
                *ngIf="emptyInstallBaseCeaseCust"
              ></px-alert>
              <px-alert
                [alerts]="[
                  {
                    type: 'info',
                    description: 'overview.error.emptyInstallBaseNewCust' | translate,
                    isClosable: false,
                    useNegativeColors: true
                  }
                ]"
                *ngIf="emptyInstallBaseNewCust"
              ></px-alert>
              <px-alert
                [alerts]="[
                  {
                    type: 'info',
                    description: 'overview.error.emptyInstallBaseV1Cust' | translate,
                    isClosable: false,
                    useNegativeColors: true
                  }
                ]"
                *ngIf="emptyInstallBaseV1Cust"
              ></px-alert>
              <!--START MESSAGE BOX-->
              <mprd-message-box
                *ngIf="copperOutPhasingOffer"
                [messageBox]="{
                  type: 'warning',
                  title: copperOutPhasingOffer?.content?.offerTitle,
                  description: copperOutPhasingOffer?.content?.shortDescription,
                  btnLabel: copperOutPhasingOffer?.content?.moreInfoLabel?.value,
                  btnUrl: copperOutPhasingOffer?.content?.offerDetailPage
                }"
                taggingName="product.overview"
                data-cy="copperStopSelling"
              ></mprd-message-box>
              <!--START IN PACK PRODUCTS-->
              <div
                *ngFor="
                  let pack of packs | filterByAddress: selectedAddress;
                  first as first;
                  last as last;
                  let index = index
                "
              >

                <!--  each pack is rendered inside this row div-->
                <div class="row">
                <!-- pack name,installation address,add new product-->
                  <div class="columns small-12 medium-4">
                    <div class="panel small-only-text-center clearfix" [ngClass]="getPanelClass()">
                      <h2 class="rs-tit3 rs-has-subtit rs-txt-c1">
                        {{ pack.packDescription }}
                      </h2>
                      <p class="rs-txt-s5">
                        <mprd-address
                          [address]="installationAddresses[pack.addressKey]"
                          [showInOneLine]="false"
                        ></mprd-address>
                      </p>
                    </div>

                    <mprd-fiber-migration
                      *ngIf="pack.isFiberEligible"
                      [pack]="pack"
                      [isSE]="isSE"
                      [isRES]="isRES"
                      [lomKey]="installationAddresses[pack.addressKey]?.lomKey"
                    ></mprd-fiber-migration>
                    <ng-container *ngIf="pack && pack?.ctaProducts">
                      <div class="panel clearfix">
                        <p>
                          <button
                            class="rs-link-action rs-link-action-add jsrs-toaster"
                            aria-haspopup="true"
                            (click)="navigateToAddAProduct(pack)"
                          >
                            <span class="rs-link-action-label" aria-hidden="true">
                              {{ 'products.overview.addProductLabel' | translate }}
                            </span>
                            <span
                              class="rs-action-link-icon"
                              title="{{ 'products.overview.addProductLabel' | translate }}"
                            >
                              <span class="show-for-sr">
                                {{ 'products.overview.addProductLabel' | translate }}
                              </span>
                            </span>
                          </button>
                        </p>
                      </div>
                    </ng-container>
                  </div>
                  <!--products inside the pack-->
                  <div class="columns small-12 medium-8">
                    <div class="rs-flex-row" data-masonry-container>
                      <div class="rs-flex-columns small-12 medium-6" data-masonry-item-sizer>
                        <div *ngFor="let product of pack.coreProducts; first as first">
                          <mprd-card
                            [product]="product"
                            [isMyMobile]="index === myMobile?.packIndex && first"
                            [isAllowedToRedirectToEshare]="!isPrepaid && hasCustomerId"
                          ></mprd-card>
                        </div>
                        <div
                          *ngFor="
                            let product of pack.nonCoreProducts
                              | removeDuplicateProducts
                              | aggregateNortonProducts
                          "
                        >

                          <ng-container *ngIf="!(easyProtectFlag && hasProductDescription && (product.productDescription === 'Proximus Secure Net Fix' || product.productDescription === 'Proximus Secure Net Mobile'))">
                            <mprd-card [product]="product"></mprd-card>
                          </ng-container>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="panel hide-for-medium-up jsrs-clickable"
                  style="cursor: pointer"
                  *ngIf="pack && pack.ctaProducts"
                >
                  <div class="panel clearfix">
                    <p>
                      <button
                        class="rs-link-action rs-link-action-add jsrs-toaster"
                        aria-haspopup="true"
                        (click)="navigateToAddAProduct(pack)"
                      >
                        <span class="rs-link-action-label" aria-hidden="true">
                          {{ 'products.overview.addProductLabel' | translate }}
                        </span>
                        <span
                          class="rs-action-link-icon"
                          title="{{ 'products.overview.addProductLabel' | translate }}"
                        >
                          <span class="show-for-sr">
                            {{ 'products.overview.addProductLabel' | translate }}
                          </span>
                        </span>
                      </button>
                    </p>
                  </div>
                </div>
                <hr
                  *ngIf="!last || outOfPacks.length > 1"
                  class="rs-margin-top2 rs-padding-bottom2-m"
                />
              </div>
              <!--END IN PACK PRODUCTS-->
              <!--START OUT OF PACK PRODUCTS-->
              <div
                *ngFor="
                  let outOfPack of outOfPacks | filterByAddress: selectedAddress;
                  first as first;
                  last as last
                "
              >
                <div class="row">
                  <div class="columns small-12 medium-4">
                    <div class="panel" [ngClass]="getPanelClass()" *ngIf="!isEBU">
                      <h2
                        *ngIf="first && (outOfPacks | filterByAddress: selectedAddress)?.length > 0"
                        class="rs-tit3 rs-has-subtit rs-txt-c1"
                      >
                        {{
                          packs?.length > 0
                            ? ('products.overview.otherProducts' | translate)
                            : ('products.overview.uniqueProducts' | translate)
                        }}
                      </h2>
                      <p class="rs-txt-s5" *ngIf="!hasOnlyProductsWithoutAddress">
                        <mprd-address
                          [address]="installationAddresses[outOfPack.addressKey]"
                          [showInOneLine]="false"
                        ></mprd-address>
                      </p>
                    </div>

                    <mprd-fiber-migration
                      *ngIf="outOfPack && containsFiberEligibleProducts(outOfPack)"
                      [isOutOfPack]="true"
                      [isSE]="isSE"
                      [isRES]="isRES"
                      [pack]="outOfPack"
                      [lomKey]="installationAddresses[outOfPack.addressKey]?.lomKey"
                    ></mprd-fiber-migration>

                    <ng-container *ngIf="outOfPack && hasCtaProduct(outOfPack)">
                      <div class="panel clearfix">
                        <p>
                          <button
                            class="rs-link-action rs-link-action-add jsrs-toaster"
                            aria-haspopup="true"
                            (click)="navigateToAddAProduct(outOfPack, true)"
                          >
                            <span class="rs-link-action-label" aria-hidden="true">
                              {{ 'products.overview.addProductLabel' | translate }}
                            </span>
                            <span
                              class="rs-action-link-icon"
                              title="{{ 'products.overview.addProductLabel' | translate }}"
                            >
                              <span class="show-for-sr">{{
                                'products.overview.addProductLabel' | translate
                              }}</span>
                            </span>
                          </button>
                        </p>
                      </div>
                    </ng-container>
                  </div>
                  <div class="columns small-12 medium-8">
                    <div class="rs-flex-row" data-masonry-container>
                      <div class="rs-flex-columns small-12 medium-6" data-masonry-item-sizer>
                        <div *ngFor="let product of outOfPack.coreProducts">
                          <mprd-card
                            [product]="product"
                            [outOfPackCardZoneTagging]="
                              packs?.length > 0
                                ? ('products.overview.otherProducts' | translate)
                                : ('products.overview.uniqueProducts' | translate)
                            "
                            [isAllowedToRedirectToEshare]="!isPrepaid"
                          ></mprd-card>
                        </div>
                        <div
                          *ngFor="
                            let product of outOfPack.nonCoreProducts
                              | removeDuplicateProducts
                              | aggregateNortonProducts
                          "
                        >
                          <ng-container *ngIf="!(easyProtectFlag && isOutOfPackNorton && product.productDescription === 'Norton Security 5' && !nortonSubscriptionGreaterThanOne)">
                            <mprd-card
                              [product]="product"
                              [outOfPackCardZoneTagging]="
      packs?.length > 0
        ? ('products.overview.otherProducts' | translate)
        : ('products.overview.uniqueProducts' | translate)
    "
                            ></mprd-card>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr *ngIf="!last" class="rs-margin-top2 rs-padding-bottom2-m" />
                <div *ngIf="last" class="rs-me"></div>
              </div>
              <!--END OUT OF PACK PRODUCTS-->
              <px-easy-switch *ngIf="isRES || isSE"></px-easy-switch>

              <div class="rs-me2"></div>
              <p
                class="text-center medium-text-right"
                *ngIf="
                  !emptyInstallBase &&
                  !emptyInstallBaseCeaseCust &&
                  !emptyInstallBaseNewCust &&
                  !isEBU
                "
              >
                <a
                  href="{{ 'overview.fullCease.link' | translate }}"
                  class="rs-txt-s2"
                  data-tms-event="link-click"
                  data-tms-link-zone="product overview"
                  attr.data-tms-link-name="{{ 'overview.fullCease.label' | translate }}"
                  attr.data-tms-link-url="{{ 'overview.fullCease.link' | translate }}"
                  >{{ 'overview.fullCease.label' | translate }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</section>
